var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffc500;}.cls-3{fill:#ff9f1e;}.cls-4{fill:#ffe059;}.cls-5{fill:#00305f;}.cls-6{fill:#e85d00;}.cls-7{fill:#ff4f4f;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1025,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1068.5,1551.8c-339,0-613.7-274.8-613.7-613.7a613.5,613.5,0,0,1,44.4-229.8A610.7,610.7,0,0,0,411.3,1025c0,338.9,274.8,613.7,613.7,613.7,257.7,0,478.3-158.8,569.2-383.9C1486.8,1432.8,1291.5,1551.8,1068.5,1551.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,411.3A610.4,610.4,0,0,0,659.9,531.7a706.9,706.9,0,0,1,453.2-18.9,27.8,27.8,0,0,0-3.3,5.1c-18.2,33.9,18.9,89.1,82.7,123.3s130.4,34.6,148.6.8a38.6,38.6,0,0,0,3.7-10.5c165.2,128,271.9,328.1,272.9,553.1a613.3,613.3,0,0,0,21-159.6C1638.7,686.1,1363.9,411.3,1025,411.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1052.7,
    cy: 565.7,
    rx: 30.8,
    ry: 42.1,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 36.42, 1194.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1034.4,1431.9h-18.8c-116.8,0-211.5-94.7-211.5-211.5h0a1121.3,1121.3,0,0,1,441.8,0h0C1245.9,1337.2,1151.2,1431.9,1034.4,1431.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M798.5,713.5,828.4,774a35.7,35.7,0,0,0,26.7,19.5l66.8,9.7c29.1,4.2,40.8,39.9,19.7,60.5l-48.3,47.1a35.3,35.3,0,0,0-10.2,31.4l11.4,66.6c4.9,28.9-25.5,51-51.5,37.3l-59.8-31.4a35.6,35.6,0,0,0-33,0l-59.7,31.4c-26.1,13.7-56.5-8.4-51.5-37.3l11.4-66.6a35.3,35.3,0,0,0-10.2-31.4l-48.4-47.1c-21-20.6-9.4-56.3,19.7-60.5l66.8-9.7A35.4,35.4,0,0,0,705,774l29.9-60.5C747.9,687.1,785.5,687.1,798.5,713.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1251.5,713.5,1221.6,774a35.7,35.7,0,0,1-26.7,19.5l-66.8,9.7c-29.1,4.2-40.8,39.9-19.7,60.5l48.3,47.1a35.3,35.3,0,0,1,10.2,31.4l-11.4,66.6c-4.9,28.9,25.5,51,51.5,37.3l59.8-31.4a35.6,35.6,0,0,1,33,0l59.7,31.4c26.1,13.7,56.5-8.4,51.5-37.3l-11.4-66.6a35.3,35.3,0,0,1,10.2-31.4l48.4-47.1c21-20.6,9.4-56.3-19.7-60.5l-66.8-9.7A35.4,35.4,0,0,1,1345,774l-29.9-60.5C1302.1,687.1,1264.5,687.1,1251.5,713.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1057.7,1315.1a128.9,128.9,0,0,0-125.5,99.7,210.8,210.8,0,0,0,83.4,17.1h18.8a210.4,210.4,0,0,0,136.3-49.9A129,129,0,0,0,1057.7,1315.1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProud);
export default __webpack_public_path__ + "static/media/proud.268452bf166fa5b83c201ecd38e57eee.svg";
export { ForwardRef as ReactComponent };